import { CheckCircleOutline } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';

type Props = {
  successfulHosts: number;
  failedHosts: number;
};
export const ProgressCountDisplay = ({ successfulHosts, failedHosts }: Props) => {
  return (
    <Stack direction="row" spacing={1}>
      <Stack direction="row" alignItems="center">
        <Tooltip title={t('a11y.scans.success', { hosts: successfulHosts })}>
          <IconButton size="medium" sx={{ color: 'green' }}>
            <CheckCircleOutline fontSize="small" />
          </IconButton>
        </Tooltip>
        <Typography>{successfulHosts}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center">
        <Tooltip title={t('a11y.scans.failed', { hosts: failedHosts })}>
          <IconButton size="small" sx={{ color: 'red' }}>
            <CheckCircleOutline fontSize="small" />
          </IconButton>
        </Tooltip>
        <Typography>{failedHosts}</Typography>
      </Stack>
    </Stack>
  );
};
